import { render, staticRenderFns } from "./header.vue?vue&type=template&id=5bcfd1f8&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=5bcfd1f8&prod&scoped=true&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=5bcfd1f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcfd1f8",
  null
  
)

export default component.exports